/**
 * SEO and JSON-LD for the public marketing home route (`/`).
 * Authenticated members are redirected to `/feed` from the route loader.
 */

import i18n from '@web/src/lib/intl/i18n'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'
import { absoluteUrlForPath } from '@web/src/lib/utilsClient'

function buildHomeJsonLd(tr: typeof i18n.t): Record<string, unknown>[] {
  const siteUrl = absoluteUrlForPath('/')

  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: tr('Spicy Friends'),
      url: siteUrl,
      description: tr(
        'Spicy Friends: social network for swingers, poly, and lifestyle communities. Connect, share, and explore open-minded relationships in a safe, inclusive space.'
      ),
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: tr('Spicy Friends'),
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Guelph, Ontario Canada',
        postalCode: 'N1H 6J3',
        streetAddress: '7242 Wellington Rd 124',
      },
      email: 'support@spicyfriends.com',
      url: siteUrl,
      logo: absoluteUrlForPath('/logo-plain.webp'),
      description: tr('The leading social network for swinger, poly, and lifestyle communities worldwide.'),
    },
  ]
}

export function homePageHeadFromLoaderData() {
  const tr = i18n.t.bind(i18n)
  const pageUrl = absoluteUrlForPath('/')

  return seo({
    title: tr('Spicy Friends - Free Swinger Social Network'),
    description: tr(
      'Join the premier swinger social network! Connect with lifestyle enthusiasts, find local events, discover swinger clubs, and build meaningful relationships in our inclusive poly and swinger community.'
    ),
    image: '/logo-og-image.webp',
    url: pageUrl,
    keywords: tr(
      'swinger social network, lifestyle community, poly dating, swinger clubs, lifestyle events, open relationships, swinger friends, poly community, lifestyle dating, swinger lifestyle'
    ),
    robots: robotsMetaForEnvironment({
      production: 'index, follow',
      staging: 'noindex,nofollow',
    }),
    jsonLd: buildHomeJsonLd(tr),
  })
}
